import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Blog.css";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { Icon } from "@iconify/react";
import searchIcon from "@iconify/icons-mdi/magnify";
import closeIcon from "@iconify/icons-mdi/close";
import arrowRightIcon from "@iconify/icons-mdi/arrow-right";
import calendarIcon from "@iconify/icons-mdi/calendar-outline";
import chevronLeft from "@iconify/icons-mdi/chevron-left";
import chevronRight from "@iconify/icons-mdi/chevron-right";
import sparkIcon from "@iconify/icons-mdi/sparkles";

// Static blog fallback images
import Blog1 from "./IMG/M1.png";
import Blog2 from "./IMG/Blog2.svg";
import Blog4 from "./IMG/Blog4.svg";
import Blog6 from "./IMG/Blog6.svg";
import Blog7 from "./IMG/blog1.png";
import Blog8 from "./IMG/E2.png";
import blog9 from "./IMG/new/A2.png";
import blog10 from "./IMG/new/b1.png";
import Proven1 from "./IMG/23-08-2023/Proven1.svg";
import Benifit from "./IMG/09-2023/Blog1.svg";
import Changed from "./IMG/Chaged.svg";
import Firstday from "./IMG/FirstDay.png";
import Ad1 from "../Blog/IMG/ad1.png";

const blogsPerPage = 9;

// Pre-existing static blogs as fallback / baseline
const staticBlogData = [
  {
    img: Firstday,
    title: "Mastering the Art of Building Connections in Your First 90 Days at a New Job",
    content: "While you navigate your responsibilities and adapt to a new work environment, one of the most crucial aspects of your early days is building meaningful connections with your colleagues and leadership.",
    category: "Career Tips",
    author: "Quarec Advisory",
    date: "01/08/2023",
    route: "/Firstday",
  },
  {
    img: Ad1,
    title: "The Perfect Combo of Recruitment Marketing and Job Boards",
    content: "In the dynamic world of recruitment, Return on Investment (ROI) has emerged as a pivotal metric. Every dollar spent in the hiring process should ideally lead to a quantifiable return, whether in top-tier hires or employer branding.",
    category: "Recruitment",
    author: "HR Strategy Team",
    date: "14/08/2023",
    route: "/RecruitmentMarketing",
  },
  {
    img: Changed,
    title: "The Way We Work Has Changed – Now It's Time to Change How We Hire",
    content: "Too much talent is slipping through the net because traditional recruitment techniques are no longer suited for modern agile environments and remote-first workplace cultures.",
    category: "Industry Insights",
    author: "Tom Cornell",
    date: "20/08/2023",
    route: "/Changed",
  },
  {
    img: Benifit,
    title: "How to Create Internal Momentum for Your Employer Brand",
    content: "Employer branding is still an emerging discipline. Therefore, there is still a range of reactivity and sponsorship for employer brands from company to company. Learn how to foster cross-team buy-in.",
    category: "Employer Branding",
    author: "Quarec Team",
    date: "28/08/2023",
    route: "/Internal-Momentum",
  },
  {
    img: Proven1,
    title: "10 Proven Ways to Improve Your Hiring Process",
    content: "The hiring process refers to the steps companies take to find and hire qualified candidates for open positions. Discover 10 actionable tactics to shorten hiring cycles and attract top tier performers.",
    category: "Staffing",
    author: "Talent Acquisition",
    date: "05/09/2023",
    route: "/Proven",
  },
  {
    img: blog10,
    title: "13 Surprising Employee Onboarding Statistics in 2024",
    content: "Onboarding is a key component of new hire induction and retention. Just as agencies use recruitment software during hiring, organizations need seamless onboarding processes for new staff.",
    category: "HR Analytics",
    author: "Research Desk",
    date: "12/09/2023",
    route: "/Surprising25",
  },
  {
    img: blog9,
    title: "Uses of Recruiting Automation in Your Modern Hiring Funnel",
    content: "Automation technology is transforming recruiting. Over 75% of recruiters report that automated sourcing, screening, and interview scheduling give them a significant competitive advantage.",
    category: "HR Tech",
    author: "Tech Innovations",
    date: "19/09/2023",
    route: "/Automation",
  },
  {
    img: Blog8,
    title: "Elevating Human Connections: Generative AI Empowers Recruiters",
    content: "The rapid advancement of Generative AI technology is poised to usher in a transformative shift within the recruitment ecosystem, freeing recruiters to focus on genuine human relationships.",
    category: "AI & Future of Work",
    author: "AI Advisory Group",
    date: "25/09/2023",
    route: "/Generative-AI",
  },
  {
    img: Blog7,
    title: "7 Top Pitch Deck Mistakes Startups Always Make During Hiring Pitches",
    content: "Crafting a compelling mission statement and pitch is a critical component in an entrepreneur's quest not only for venture capital, but also for attracting founding engineering and business leaders.",
    category: "Startups & Growth",
    author: "Executive Search",
    date: "02/10/2023",
    route: "/QuationSeven",
  },
  {
    img: Blog1,
    title: "Mastering the Art of Hiring: Essential Tips and Best Practices",
    content: "Hiring the right talent is crucial for the success of any organization. However, finding the perfect fit can be a challenging and time-consuming process without structured candidate scoring.",
    category: "Recruitment",
    author: "Senior Talent Lead",
    date: "10/10/2023",
    route: "/QuestionOne",
  },
  {
    img: Blog2,
    title: "Top Insider Tips for Better Job Hunting and Interview Preparation",
    content: "Unless you are in an exceptionally high-demand niche, finding a new dream job requires structured positioning, portfolio storytelling, and strategic executive networking.",
    category: "Career Tips",
    author: "Career Coach",
    date: "18/10/2023",
    route: "/QuationTwo",
  },
  {
    img: Blog4,
    title: "9 Proven Ways to Streamline Talent Assessment and Onboarding",
    content: "Improving the assessment phase is crucial for attracting top talent and boosting long-term employee retention. Here are nine proven ways to enhance candidate experience.",
    category: "Staffing",
    author: "Talent Ops",
    date: "25/10/2023",
    route: "/QuationSix",
  }
];

function BlogCards() {
  const [currentPage, setCurrentPage] = useState(1);
  const [allBlogs, setAllBlogs] = useState(staticBlogData);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const navigate = useNavigate();

  const rawApi = process.env.REACT_APP_API_URL || (process.env.NUXT_PUBLIC_API_URL ? `${process.env.NUXT_PUBLIC_API_URL}/api` : 'https://api.khushbufoundation.com/api');
  const backendUrl = rawApi.endsWith('/api') ? rawApi : `${rawApi}/api`;
  const backendOrigin = backendUrl.replace(/\/api$/, '');

  const resolveImage = (imgUrl) => {
    if (!imgUrl) return Blog1;
    if (imgUrl.startsWith("http://") || imgUrl.startsWith("https://")) return imgUrl;
    return `${backendOrigin}${imgUrl.startsWith("/") ? "" : "/"}${imgUrl}`;
  };

  useEffect(() => {
    axios
      .get(`${backendUrl}/quarec/blogs`)
      .then((response) => {
        const liveBlogs = (response.data?.data || []).map((b) => ({
          isDynamic: true,
          _id: b._id,
          slug: b.slug,
          img: resolveImage(b.image),
          title: b.title,
          content: b.content?.replace(/<[^>]*>/g, '').slice(0, 220) + '...',
          category: b.category || "Recruitment",
          author: b.author || "Quarec Editorial",
          date: b.createdAt ? new Date(b.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "Recent",
          raw: b,
          route: `/FullBlog/${b.slug || b._id}`
        }));

        if (liveBlogs.length > 0) {
          setAllBlogs([...liveBlogs, ...staticBlogData]);
        }
      })
      .catch((error) => {
        console.warn("Could not fetch dynamic Quarec blogs, using static fallback:", error);
      });
  }, []);

  // Compute unique categories
  const categories = useMemo(() => {
    const cats = new Set(["All"]);
    allBlogs.forEach((b) => {
      if (b.category) cats.add(b.category);
    });
    return Array.from(cats);
  }, [allBlogs]);

  // Filtered blogs
  const filteredBlogs = useMemo(() => {
    return allBlogs.filter((blog) => {
      const matchesSearch =
        !searchQuery.trim() ||
        blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        blog.content.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (blog.author && blog.author.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesCategory =
        selectedCategory === "All" || blog.category === selectedCategory;

      return matchesSearch && matchesCategory;
    });
  }, [allBlogs, searchQuery, selectedCategory]);

  // Featured Hero Blog (first dynamic blog or top static blog)
  const featuredBlog = useMemo(() => {
    if (searchQuery || selectedCategory !== "All") return null;
    return filteredBlogs[0] || null;
  }, [filteredBlogs, searchQuery, selectedCategory]);

  // Grid blogs excluding the featured one when no active filter
  const gridBlogs = useMemo(() => {
    if (!searchQuery && selectedCategory === "All" && featuredBlog) {
      return filteredBlogs.slice(1);
    }
    return filteredBlogs;
  }, [filteredBlogs, featuredBlog, searchQuery, selectedCategory]);

  const totalPages = Math.ceil(gridBlogs.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const currentGridBlogs = gridBlogs.slice(startIndex, startIndex + blogsPerPage);

  const handleCardClick = (blog) => {
    if (blog.isDynamic) {
      navigate(blog.route, { state: { props: blog.raw } });
    } else {
      navigate(blog.route);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 380, behavior: "smooth" });
  };

  return (
    <div className="qr-blog-page">
      <Helmet>
        <title>Quarec Insights & Blog | Executive Recruitment & HR Strategy</title>
        <meta
          name="description"
          content="Explore the latest insights on recruitment marketing, talent acquisition, AI in hiring, and workforce strategy from Quarec Resources."
        />
        <meta name="keywords" content="HR insights, recruitment, staffing solutions, hiring strategy, Quarec Resources" />
      </Helmet>

      {/* Hero Header */}
      <section className="qr-blog-hero">
        <div className="qr-hero-badge">
          <Icon icon={sparkIcon} style={{ fontSize: "15px" }} />
          <span>Knowledge & Insights</span>
        </div>
        <h1 className="qr-hero-title">
          Perspectives on <span>Talent, Strategy</span> & Enterprise Growth
        </h1>
        <p className="qr-hero-subtitle">
          Discover thought leadership, industry benchmarks, and actionable talent acquisition strategies curated by Quarec's executive recruitment consultants.
        </p>
      </section>

      {/* Search & Category Filter Controls */}
      <div className="qr-blog-controls">
        <div className="qr-controls-card">
          <div className="qr-search-wrapper">
            <Icon icon={searchIcon} className="qr-search-icon" />
            <input
              type="text"
              placeholder="Search articles by title, topic, or keyword..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
              className="qr-search-input"
            />
            {searchQuery && (
              <button
                className="qr-search-clear"
                onClick={() => {
                  setSearchQuery("");
                  setCurrentPage(1);
                }}
                title="Clear Search"
              >
                <Icon icon={closeIcon} />
              </button>
            )}
          </div>

          <div className="qr-categories-scroll">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`qr-cat-pill ${selectedCategory === cat ? "active" : ""}`}
                onClick={() => {
                  setSelectedCategory(cat);
                  setCurrentPage(1);
                }}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Spotlight / Featured Article (shown on main page when unfiltered) */}
      {featuredBlog && (
        <section className="qr-featured-container">
          <div className="qr-featured-card" onClick={() => handleCardClick(featuredBlog)}>
            <div className="qr-featured-media">
              <img
                src={featuredBlog.img}
                alt={featuredBlog.title}
                className="qr-featured-img"
              />
              <div className="qr-featured-overlay">
                <span className="qr-pill-featured">Featured Story</span>
                {featuredBlog.isDynamic && (
                  <span className="qr-pill-featured" style={{ background: "#d4a373" }}>
                    Live Article
                  </span>
                )}
              </div>
            </div>

            <div className="qr-featured-body">
              <div className="qr-meta-row">
                <span className="qr-meta-category">{featuredBlog.category}</span>
                <span className="qr-meta-dot"></span>
                <span>{featuredBlog.date}</span>
              </div>

              <h2 className="qr-featured-title">{featuredBlog.title}</h2>
              <p className="qr-featured-excerpt">{featuredBlog.content}</p>

              <div className="qr-featured-footer">
                <div className="qr-author-box">
                  <div className="qr-author-avatar">
                    {featuredBlog.author ? featuredBlog.author.charAt(0) : "Q"}
                  </div>
                  <div>
                    <div className="qr-author-name">{featuredBlog.author}</div>
                    <div className="qr-author-role">Quarec Resources</div>
                  </div>
                </div>

                <div className="qr-read-link">
                  <span>Read Full Article</span>
                  <Icon icon={arrowRightIcon} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Grid of Articles */}
      <section className="qr-grid-container">
        <div className="qr-section-header">
          <h2 className="qr-section-title">
            {searchQuery ? `Search Results for "${searchQuery}"` : selectedCategory !== "All" ? `${selectedCategory} Articles` : "Recent Publications"}
          </h2>
          <span className="qr-section-count">
            Showing {gridBlogs.length} {gridBlogs.length === 1 ? "article" : "articles"}
          </span>
        </div>

        {currentGridBlogs.length === 0 ? (
          <div className="qr-empty-box">
            <Icon icon={searchIcon} className="qr-empty-icon" />
            <h3 className="qr-empty-title">No articles found matching your criteria</h3>
            <p className="qr-empty-sub">Try searching with different terms or selecting another category.</p>
            <button
              className="qr-empty-reset"
              onClick={() => {
                setSearchQuery("");
                setSelectedCategory("All");
              }}
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="qr-articles-grid">
            {currentGridBlogs.map((blog, idx) => (
              <article
                key={blog._id || idx}
                className="qr-article-card"
                onClick={() => handleCardClick(blog)}
              >
                <div className="qr-card-media">
                  <img
                    src={blog.img}
                    alt={blog.title}
                    className="qr-card-img"
                    loading="lazy"
                  />
                  <div className="qr-card-badge-box">
                    <span className={`qr-card-badge ${blog.isDynamic ? "dynamic" : ""}`}>
                      {blog.category}
                    </span>
                    {blog.isDynamic && (
                      <span className="qr-card-badge" style={{ background: "#1b4b4e", color: "#fff" }}>
                        New
                      </span>
                    )}
                  </div>
                </div>

                <div className="qr-card-body">
                  <div className="qr-card-date">
                    <Icon icon={calendarIcon} style={{ fontSize: "14px" }} />
                    <span>{blog.date}</span>
                  </div>

                  <h3 className="qr-card-title" title={blog.title}>
                    {blog.title}
                  </h3>

                  <p className="qr-card-excerpt">{blog.content}</p>

                  <div className="qr-card-footer">
                    <div className="qr-card-author">
                      <span className="qr-author-dot">
                        {blog.author ? blog.author.charAt(0) : "Q"}
                      </span>
                      <span>{blog.author}</span>
                    </div>

                    <span className="qr-card-cta">
                      <span>Read</span>
                      <Icon icon={arrowRightIcon} />
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

        {/* Modern Pagination */}
        {totalPages > 1 && (
          <div className="qr-pagination">
            <button
              className="qr-page-btn"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
              title="Previous Page"
            >
              <Icon icon={chevronLeft} style={{ fontSize: "20px" }} />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                className={`qr-page-btn ${currentPage === page ? "active" : ""}`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="qr-page-btn"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
              title="Next Page"
            >
              <Icon icon={chevronRight} style={{ fontSize: "20px" }} />
            </button>
          </div>
        )}
      </section>
    </div>
  );
}

export default BlogCards;
